import {
  MDBFooter,
  MDBRow,
} from 'mdb-react-ui-kit';
import { Container } from 'react-bootstrap'; 


export default function Footer() {
	return(
    <MDBFooter className='footer-design text-white'>
      <div className='container p-4'>
        <MDBRow>
          <div className='col-lg-6 col-md-12 mb-4 mb-md-0'>
          <Container>
            <h5 className='text-uppercase footer-title'>@martikitikitee</h5>

            <p>
              This is a web developer's portfolio showcasing projects developed during my career as a full stack web developer. 
            </p>
          </Container>
          </div>

          <div className='col-lg-3 col-md-6 mb-4 mb-md-0'>
          <Container>
            <h5 className='text-uppercase  footer-title mb-0'>Digital Footprints</h5>

            <ul className='list-unstyled'>
              <li>      
                LinkedIn               
              </li>
                <li>  
                    Instagram                               
                </li>
              <li>
              </li>
            </ul>
          </Container>
          </div>
        </MDBRow>
      </div>

      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        ©2022 Copyright: @martikitikitee Developer's Portfolio
      </div>
    </MDBFooter>
	);
};